"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Placeholder["default"];
  }
});
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }